import React from 'react';

import { ModuleProps } from '../../../types';
import SupportLayout from '../components/SupportLayout';
import { SupportView } from '../types';

const SupportCategory: React.FC<ModuleProps> = props => {
  return <SupportLayout view={SupportView.TOPIC} {...props} />;
};

export default SupportCategory;
